import type { Notification } from 'types'
import store from './store'

export const notifications = store<Notification[]>([])
